<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('settings.transaltion.addTranslation') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="service-translation-add-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('ui.language') }}:
            </label>

            <d-form-select
              v-model="language"
              :options="languageOptions" />
          </div>

          <div class="form-group">
            <label>
              <template v-if="isServiceGroup">
                {{ $t('service.group.serviceGroupName') }}:
              </template>
              <template v-else>
                {{ $t('service.serviceName') }}:
              </template>
            </label>

            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="name" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div
            v-if="!isServiceGroup"
            class="form-group">
            <label for="intro">
              {{ $t('ui.shortDescription') }}:
            </label>

            <validation-provider
              rules="required"
              name="intro"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="intro" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div
            v-if="!isServiceGroup"
            class="form-group">
            <label for="description">
              {{ $t('service.serviceDescription') }}:
            </label>

            <validation-provider
              rules="required"
              name="description"
              v-slot="{ errors }">
              <d-textarea
                :state="errors.length ? 'invalid' : null"
                v-model="description" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div
            v-if="!isServiceGroup"
            class="form-group">
            <label for="catalog_url">
              {{ $t('service.catalogUrl') }}:
            </label>

            <validation-provider
              rules="valid-url"
              name="catalog_url"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="catalog_url" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        <i class="material-icons">add</i>
        {{ $t('settings.transaltion.addTranslation') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'service-translation-new-popup',
  props: {
    serviceID: {
      default: 0,
      type: Number
    },
    serviceGroupID: {
      default: 0,
      type: Number
    },
    languages: {
      default: () => ([]),
      type: Array
    }
  },
  computed: {
    isServiceGroup () {
      return !this.serviceID && !!this.serviceGroupID;
    },
    languageOptions () {
      return this.languages.map(language => ({
        value: language.id,
        text: language.name
      }));
    }
  },
  data () {
    return {
      language: this.languages[0].id,
      name: '',
      intro: '',
      description: '',
      catalog_url: ''
    };
  },
  methods: {
    handleClose (newTranslationID = false) {
      let eventName = 'service-translation-new-popup-close';

      if (this.isServiceGroup) {
        eventName = 'service-group-translation-new-popup-close';
      }

      this.$bus.$emit(eventName, newTranslationID);
    },
    validateForm () {
      FormUtils.validate(this.$refs['service-translation-add-form'], this.saveTranslation);
    },
    saveTranslation () {
      let endpointUrl = '/services/translations/store';
      let dataToSend = {
        service_id: this.serviceID,
        language_id: this.language,
        name: this.name,
        intro: this.intro,
        description: this.description,
        catalog_url: this.catalog_url
      };

      if (this.isServiceGroup) {
        endpointUrl = '/services/groups/translations/store';
        dataToSend = {
          group_id: this.serviceGroupID,
          language_id: this.language,
          name: this.name
        };
      }

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: dataToSend,
        successTitle: this.$t('settings.transaltion.addTranslationSuccessTitle'),
        successText: this.$t('settings.transaltion.addTranslationSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.transaltion.addTranslationErrorText'),
        successAction: res => {
          let eventName = 'service-reload-translations';

          if (this.isServiceGroup) {
            eventName = 'service-group-reload-translations';
          }

          this.$bus.$emit(eventName);
          this.handleClose(res.id);
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
